import { TransactionType } from '@libs/types';
import {
  DepositIconGe,
  MinusIconGe,
  PlusIconGe,
  WithdrawIconGe,
} from 'src/assets';

export const TransactionFiltersDefaultValue = {
  TYPE: [],
  ASSET: [],
  STATUS: [],
  MINDATE: undefined,
  MAXDATE: undefined,
};

export const TRANSACTION_LABELS: Record<string, string> = {
  [TransactionType.Buy]: 'dashboard_buy',
  [TransactionType.Sell]: 'dashboard_sell',
  [TransactionType.Deposit]: 'dashboard_deposit',
  [TransactionType.Withdrawal]: 'dashboard_withdraw',
  [TransactionType.BonusClaim]: 'dashboard_bonus_claim',
};
export const TRANSACTION_OPERATIONS_TITLE: Record<string, string> = {
  [TransactionType.Buy]: 'common_paid',
  [TransactionType.Sell]: 'common_sold',
  [TransactionType.Deposit]: 'common_recived',
  [TransactionType.Withdrawal]: 'staking_details_redeemed',
  [TransactionType.BonusClaim]: 'common_recived',
};
export const TRANSACTION_ICONS: Record<string, JSX.Element> = {
  [TransactionType.Buy]: <PlusIconGe />,
  [TransactionType.Sell]: <MinusIconGe />,
  [TransactionType.Deposit]: <DepositIconGe />,
  [TransactionType.Withdrawal]: <WithdrawIconGe />,
  [TransactionType.BonusClaim]: <MinusIconGe />,
};

export { TransactionType };
